"use client";

let ctx: AudioContext | null = null;

/** A short wooden "tock" made with Web Audio, so no sound files are needed. */
export function playMoveSound(kind: "move" | "capture" | "check" | "end" = "move") {
  if (typeof window === "undefined") return;
  try {
    if (localStorage.getItem("atlas:sound") === "off") return;
  } catch {
    /* storage blocked: play anyway */
  }
  try {
    ctx ??= new AudioContext();
    const t = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const freq = { move: 420, capture: 300, check: 620, end: 220 }[kind];
    osc.type = "triangle";
    osc.frequency.setValueAtTime(freq, t);
    osc.frequency.exponentialRampToValueAtTime(freq * 0.55, t + 0.09);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(kind === "capture" ? 0.32 : 0.22, t + 0.005);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + (kind === "end" ? 0.5 : 0.12));
    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.55);
  } catch {
    /* audio unavailable */
  }
}
